module.exports = __webpack_public_path__ + "img/creative-tests.33e27d02.svg";